<template>
    <div :style="position" class="shot" @click.prevent="changeActiveShot">
        <a :class="{ active: activeShotIndex == index }" href=""> </a>
    </div>
</template>
<script>
export default {
    props: [
        "index",
        "activeShotIndex",
        "shot",
        "courseSize",
        "maxSliderValueHorizon",
        "maxSliderValueVertically",
        "graphId",
    ],
    computed: {
        position() {
            if (!this.shot) {
                return false;
            }

            return {
                bottom: this.getPositionPoint(this.shot.vertically, this.maxSliderValueVertically),
                left: this.getPositionPoint(this.shot.horizon, this.maxSliderValueHorizon),
            };
        },
    },
    methods: {
        changeActiveShot() {
            this.$emit("changeActiveShot", this.index);
        },
        getPositionPoint(value, maxValue) {
            const percent = this.getPercentPoint(value, maxValue);
            const correction = this.courseSize * (percent / 100);
            return `calc(${percent}% - ${correction}px)`;
        },
        getPercentPoint(value, maxValue) {
            const nValue = Number(value);
            const nMaxValue = Number(maxValue);
            return ((nValue + maxValue) * 100) / (nMaxValue * 2);
        },
    },
};
</script>

<style lang="scss" scoped>
.shot {
    position: absolute;
    display: inline-block;
    z-index: 1;
    margin-left: -12px;
    margin-bottom: -12px;
    a {
        background: #267962;
        border-radius: 100%;
        display: block;
        width: 14px;
        height: 14px;

        &.active {
            background: #15f29f;
        }
    }

    padding: 12px;
}
</style>
